module.exports = __webpack_public_path__ + "static/media/revisar.63560707.png";